// store/slices/adminReferralRewardsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./AccountLogoutThunk";
// Fetch history



export const fetchReferralRewardHistory = createAsyncThunk(
  "adminReferralRewards/fetchHistory",
  async (_, thunkAPI) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/invite-referral-rewards/history`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "Failed to fetch history");

      return json.data || [];
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Update reward
export const updateReferralReward = createAsyncThunk(
  "adminReferralRewards/updateReward",
  async (rewardAmount, thunkAPI) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/invite-referral-rewards/update`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
        body: JSON.stringify({ reward_amount: rewardAmount }),
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "Failed to update reward");

      return json.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

const adminReferralRewardsSlice = createSlice({
  name: "adminReferralRewards",
  initialState: {
    history: [],
    loading: false,
    error: null,
    updating: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralRewardHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralRewardHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload;
      })
      .addCase(fetchReferralRewardHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateReferralReward.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateReferralReward.fulfilled, (state) => {
        state.updating = false;
      })
      .addCase(updateReferralReward.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      });
  },
});

export default adminReferralRewardsSlice.reducer;
